import { ExperimentTemplatePreview } from '@experiment-details/types';
import { ViewItemData } from '@shared/components/ViewSelect/utils';

export const expTemplateToProjectOptionItem = (
  template: ExperimentTemplatePreview
): ViewItemData => ({
  name: template.templateName ?? '',
  isDefault: template.defaultTemplate,
  id: template.templateId as string
});

export const expTemplateToWorkspaceOptionItem = (
  template: ExperimentTemplatePreview
): ViewItemData => ({
  name: template.templateName ?? '',
  source: template.projectName,
  isDefault: template.defaultTemplate,
  id: template.templateId as string,
  disabledActions: {
    default: true
  }
});
